import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle5Pg() {
    return(
        <>
            
                <div className='container'>
                    <div className='mt-1 ms-3'>
                        <h4>Information as may be Prescribed </h4>
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>S. No.</strong>
                                    </td>
                                    <td>
                                        <strong>Item</strong>
                                    </td>
                                    <td>
                                        <strong>Details</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>5.1</strong>
                                    </td>
                                    <td colspan="2">
                                        <strong>Such other information as may be prescribed [F.No.1/2/2016-IR dt.17.8.2016, F.No.1/6/2011-IR dt. 15.4.2013]</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        5.1.1(a)
                                    </td>
                                    <td>
                                        Name &amp; details of - (a) Current CPIOs &amp; FAAs,</td>
                                        <td>
                                        <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/rti/5_1_1_a_2026.pdf"} target="_blank">Click Here</Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        5.1.1(b)
                                    </td>
                                    <td>
                                        Name & details of - (b) Earlier CPIO & FAAs,</td>
                                    <td>
                                        <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/rti/5_1_1_b_2026.pdf"} target="_blank;">Click Here</Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        5.1.2
                                    </td>
                                    <td>
                                        Details of third party audit of voluntary disclosure - <br /><br />
                                        1.Transparency Audit Report 2023–24 <br /> (a) Dates of audit carried out: <br /> (b) Audit Report<br /><br />
                                        2.Transparency Audit Report 2024–25 <br /> (a) Date of audit carried out:  <br /> (b) Audit Report<br /><br />
                                        3.Transparency Audit Report 2025–26 <br /> (a) Date of audit carried out:  <br /> (b) Audit Report<br />
                                    </td>
                                    <td><br />
                                <br />  (a) 19th June 2024<br />
                                        (b)<Link className="c-link" to={"https://files.iittp.ac.in/pdfs/rti/2023/Audit_Report_2023_24.pdf"} target="_blank">AuditReport</Link><br /><br /><br />

                                        (a) 09 June 2025<br />
                                        (b)<Link className="c-link" to={"https://files.iittp.ac.in/2026/rti/Audit_Report_2024_25.pdf"} target="_blank">AuditReport</Link><br /><br /><br />

                                        (a)22 June 2026<br />
                                        (b)<Link className="c-link" to={"https://files.iittp.ac.in/2026/rti/Audit_Report_2025_26.pdf"} target="_blank">AuditReport</Link>
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td>
                                        5.1.3
                                    </td>
                                    <td>
                                        Appointment of Nodal Officers not below the rank of Joint Secretary / Additional HoD - (a) Date of appointment, (b) Name &amp; Designation of the officers
                                    </td>
                                    <td>
                                        04 June 2025<br />
                                        Brig. Dr. K. P. Krishna Kumar (Retd.)<br />
                                        Registrar
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        5.1.4
                                    </td>
                                    <td>
                                        Consultancy Committee of key stake holders for advice on suo-moto disclosure &ndash; (a) Dates from which constituted (b) Name &amp; Designation of the officers
                                    </td>
                                    <td>
                                        <Link className="c-link" to={"https://files.iittp.ac.in/pdfs/rti/2023/Consultancy_Committee_25.pdf"} target="_blank">Consultancy Committee</Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        5.1.5
                                    </td>
                                    <td>
                                        Committee of PIOs / FAAs with rich experience in RTI to identify frequently sought information under RTI &ndash; (a) Dates from which constituted (b) Name &amp; Designation of the Officers
                                    </td>
                                    <td>
                                        Not Applicable
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

        </>
    );
}

export default RTISection4AdministrationEle5Pg;